import * as React from "react";
import EdButton from "../../../../generic/edButton";
import "../../../../../assets/scss/components/toc/orderBook/obModifyState/obModify.scss";
import "../../../../../assets/scss/components/toc/orderBook/obDetails/obAssetDetails.scss";
import "../../../../../assets/scss/components/toc/orderBook/obDetails/obAssetDetailstab.scss";
import ObAssetsDetl, { ObAssetsDetlProps } from "../../instruments/details/obAssetsDetl";
import moment from "moment";
import ObMfSiphisDtlContent from "./obMfSipDtlContent";
import { ChipStatusComb } from "../../obConstants";

export interface IObMfSipDtlDskProps {
	data: any;
	onBackClick: (event: React.MouseEvent<HTMLButtonElement>) => void; // the function to be called onClick
	onCancelClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ObMfSipDtlDsk: React.FC<IObMfSipDtlDskProps> = (props) => {
	const backButtonValue = (
		<>
			<i className="arrow_left edel-icon-arrow-left vTextTop" />
			<span>Back</span>
		</>
	);

	const assetDetail: ObAssetsDetlProps = {
		date: props.data.txnDate ? moment(new Date(props.data.txnDate)).format("D MMM YYYY, HH:mm:ss") : "",
		trsTyp: "BUY",
		title: props.data.schemeName,
		sts: ChipStatusComb[props.data.status.toLowerCase()]
	};
	return (
		<div>
			<section className="ob_detail_container">
				<section className="ob_detail_wrapper">
					<section className="list_view">
						<div className="ly_list_view ">
							{/* left menu back button */}
							<div className="lv_menu bckBtnDiv ">
								<EdButton value={backButtonValue} btnTyp="link" onClick={props.onBackClick} className="icon_button" />
							</div>
						</div>
						<div className="ob_right_cont ly_right_cont">
							<div className="ob_detail_view">
								{/* header section */}
								<div className="dv_content">
									<div className="ob_header">
										<ObAssetsDetl {...assetDetail} />
									</div>
									{/* detailed content */}
									<ObMfSiphisDtlContent data={props.data} onCancelClick={props.onCancelClick} />
								</div>
							</div>
						</div>
					</section>
				</section>
			</section>
		</div>
	);
};

export default ObMfSipDtlDsk;
